
<template>
  <v-container
    fluid
    class="rounded-lg elevation-3 px-4 py-4 d-flex flex-column"
    style="height: 100%; background-color: var(--color-bg)"
  >
    <slot name="header" />
    <v-container
      class="pa-0"
      style="background-color: transparent; height: 100%; position: relative"
    >
      <highcharts
        :options="topChartOptions"
        class="chart-container"
      />
    </v-container>
    <v-container
      class="pa-0"
      style="background-color: transparent; height: 100%; position: relative"
    >
      <highcharts
        :options="bottomChartOptions"
        class="chart-container"
      />
    </v-container>
  </v-container>
</template>

<script>
export default {
  name: "ChartContainer",
  props: {
    topChartOptions: {
      type: Object,
      required: true,
    },
    bottomChartOptions: {
      type: Object,
      required: true,
    },
  },
};
</script>

  <style scoped>
.chart-container {
  height: 100%;
  width: 100%;
  position: absolute;
}
</style>
